<div #imageZoom class="db-image-zoom" [ngStyle]="imageZoomStyle">
  <div class="zoom-image" [ngStyle]="{backgroundImage: 'url(' + content + ')'}"></div>
</div>
